import React from "react";

const Terms = () => {
  const lastUpdated = "March 29, 2026";

  const styles = {
    outerContainer: {
      backgroundColor: "#f8fafc",
      minHeight: "100vh",
      width: "100%",
      padding: "24px 5%",
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      color: "#0f172a",
      lineHeight: "1.5",
      boxSizing: "border-box",
    },
    contentWrapper: {
      width: "100%",
      maxWidth: "1400px",
      margin: "0 auto",
    },
    header: {
      marginBottom: "15px",
      textAlign: "left",
      borderBottom: "1px solid #e2e8f0",
      paddingBottom: "10px",
    },
    title: {
      fontSize: "48px",
      fontWeight: "900",
      letterSpacing: "-0.025em",
      margin: "0 0 16px 0",
    },
    lastUpdatedText: {
      color: "#64748b",
      fontSize: "14px",
      textTransform: "uppercase",
      letterSpacing: "0.1em",
      fontWeight: "500",
    },
    dateHighlight: {
      color: "#2563eb",
    },
    policyCard: {
      backgroundColor: "#ffffff",
      padding: "30px",
      borderRadius: "24px",
      boxShadow:
        "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
      border: "1px solid #f1f5f9",
      display: "flex",
      flexDirection: "column",
      gap: "20px",
    },
    section: {
      position: "relative",
    },
    headingGroup: {
      display: "flex",
      alignItems: "center",
      marginBottom: "24px",
    },
    accentBar: {
      width: "40px",
      height: "5px",
      backgroundColor: "#2563eb",
      marginRight: "16px",
      borderRadius: "9999px",
    },
    sectionTitle: {
      fontSize: "28px",
      fontWeight: "800",
      margin: "0",
    },
    paragraph: {
      color: "#475569",
      lineHeight: "1.8",
      fontSize: "18px",
      paddingLeft: "56px",
      margin: "0",
    },
    contactBanner: {
      backgroundColor: "#0f172a",
      borderRadius: "20px",
      padding: "50px",
      color: "#ffffff",
      marginTop: "20px",
    },
    contactTitle: {
      fontSize: "28px",
      fontWeight: "700",
      margin: "0 0 16px 0",
    },
    contactText: {
      color: "#cbd5e1",
      fontSize: "18px",
      lineHeight: "1.6",
      marginBottom: "32px",
      maxWidth: "800px",
    },
    button: {
      display: "inline-block",
      backgroundColor: "#2563eb",
      color: "#ffffff",
      fontWeight: "700",
      padding: "16px 40px",
      borderRadius: "9999px",
      textDecoration: "none",
    },
    footer: {
      marginTop: "64px",
      textAlign: "center",
      color: "#94a3b8",
      fontSize: "14px",
    },
  };

  return (
    <div style={styles.outerContainer}>
      <div style={styles.contentWrapper}>
        <header style={styles.header}>
          <h1 style={styles.title}>Terms of Service</h1>
          <p style={styles.lastUpdatedText}>
            Last Updated:{" "}
            <span style={styles.dateHighlight}>{lastUpdated}</span>
          </p>
        </header>

        <div style={styles.policyCard}>
          {/* Section 1 */}
          <section style={styles.section}>
            <div style={styles.headingGroup}>
              <span style={styles.accentBar}></span>
              <h2 style={styles.sectionTitle}>Acceptance of Terms</h2>
            </div>
            <p style={styles.paragraph}>
              By accessing and using our services, you accept and agree to be
              bound by the terms and provision of this agreement. Use of our
              platform constitutes a legally binding contract between you and
              our company.
            </p>
          </section>

          {/* Section 2 */}
          <section style={styles.section}>
            <div style={styles.headingGroup}>
              <span style={styles.accentBar}></span>
              <h2 style={styles.sectionTitle}>Use License</h2>
            </div>
            <p style={styles.paragraph}>
              Permission is granted to temporarily access the materials on our
              website for personal, non-commercial transitory viewing only. This
              is the grant of a license, not a transfer of title.
            </p>
          </section>

          {/* Section 3 */}
          <section style={styles.section}>
            <div style={styles.headingGroup}>
              <span style={styles.accentBar}></span>
              <h2 style={styles.sectionTitle}>User Responsibilities</h2>
            </div>
            <p style={styles.paragraph}>
              You are responsible for maintaining the confidentiality of your
              account and password and for restricting access to your devices.
              You agree to accept responsibility for all activities that occur
              under your account.
            </p>
          </section>

          {/* Section 4 */}
          <section style={styles.section}>
            <div style={styles.headingGroup}>
              <span style={styles.accentBar}></span>
              <h2 style={styles.sectionTitle}>Limitation of Liability</h2>
            </div>
            <p style={styles.paragraph}>
              In no event shall our company be liable for any damages
              (including, without limitation, damages for loss of data or
              profit) arising out of the use or inability to use the materials
              on our platform.
            </p>
          </section>

          {/* Contact Banner */}
          <section style={styles.contactBanner}>
            <h2 style={styles.contactTitle}>Contact Information</h2>
            <p style={styles.contactText}>
              If you have any questions about these Terms of Service or need
              further clarification, please reach out to our legal team.
            </p>
            <a href="mailto:support@yourcompany.com" style={styles.button}>
              Contact Us
            </a>
          </section>
        </div>

        <footer style={styles.footer}>
          <p>
            © {new Date().getFullYear()} Your Company Name. All Rights Reserved.
          </p>
        </footer>
      </div>
    </div>
  );
};

export default Terms;
